import React from "react";

export const BedIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <path d="M3 11V18M21 11V18M18 18H6M21 13H3M18 11V6C18 4.89543 17.1046 4 16 4H8C6.89543 4 6 4.89543 6 6V11M9 8H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export const BathIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <path d="M4 11H20V15C20 17.2091 18.2091 19 16 19H8C5.79086 19 4 17.2091 4 15V11ZM7 7V11M17 7V11M4 11C4 8.23858 6.23858 6 9 6H15C17.7614 6 20 8.23858 20 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export const SizeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <rect x="5" y="5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M9 5V19M15 5V19M5 9H19M5 15H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
};
